<template>
  <div class="m-container">
    <m_header></m_header>
    <m_menu></m_menu>
    <div class="m-body">
      <div class="m-table">
        <div style="display: flex;">
          <div style="display: flex; align-items: center;">
            <el-button type="primary" size="small" @click="openNewOpt">新增咨询专家</el-button>
          </div>
          <div style="display: flex; align-items: center;padding-left: 20px;" v-loading="isMoneyLoading">
            <div class="m-total-item">
              <span style="padding-right: 15px;">业绩总额：{{ allMoney }} 元</span>
              <span style="padding: 0 15px; border-left: 1px solid #d0d0d0; font-size: 14px;">
                苹果业绩总额：{{ allIosMoney }} 元
              </span>
              <span style="padding: 0 15px; border-left: 1px solid #d0d0d0; font-size: 14px;">
                安卓业绩总额：{{ allAndroidMoney }} 元
              </span>
            </div>
          </div>
          <div class="m-expert-money" style="display: flex; align-items: center;">
            <div class="m-total-item" v-loading="isMoneyLoading">
              <span style="padding-right: 15px;">
                所属专家：<span style="color: #ff4d51;">{{ searchForm.eName }}</span>
              </span>
              <span style="padding: 0 15px; border-left: 1px solid #d0d0d0">
                专家业绩：{{ expertMoney }} 元
              </span>
              <span style="padding: 0 15px; border-left: 1px solid #d0d0d0; font-size: 14px;">
                苹果业绩：{{ expertIosMoney }} 元
              </span>
              <span style="padding-left: 15px; border-left: 1px solid #d0d0d0; font-size: 14px;">
                安卓业绩：{{ expertAndroidMoney }} 元
              </span>
            </div>
            <div class="m-dis-box-ti-tips">
              未选择日期范围时，数据均为累计数
            </div>
          </div>
        </div>
        <div class="m-enroll-opt scroll-container" v-loading="optLoading">
          <div class="scroll-list">
            <div v-for="(item, index) in optList" :key="index" :index="index" class="m-enroll-opt-item">
              <div class="m-enroll-opt-item-left" @click="listData({expertId: item.id, eName: item.eName})">
                <div class="m-enroll-opt-tit" :class="searchForm.expertId === item.id ? 'opt-selected' : ''">
                  {{ item.eName }}
                </div>
                <div class="m-enroll-opt-img">
                  <img :src="ossURL + item.imgPath" alt="" width="100%" height="100%">
                  <div class="m-enroll-opt-img-t">{{ item.eTypeText }}</div>
                  <div class="m-enroll-opt-img-click">
                    <div class="opt-img-click-text">
                      点击查询列表
                    </div>
                  </div>
                </div>
              </div>
              <div class="m-enroll-opt-item-right">
                <div>
                  <div style="text-align: center;font-size: 12px;color: #939393;">
                    {{ item.status === '1' ? '已开启' : '已关闭' }}
                  </div>
                  <div style="text-align: center;" @click="submitExpertStatus(item.id, item.status)">
                    <el-switch :value="getExpertStatus(item.status)" active-color="#13ce66" inactive-color="#939393"></el-switch>
                  </div>
                  <div style="margin-top: 20px;">
                    <el-button type="primary" size="mini" @click="openOptForm(item)">编辑</el-button>
                  </div>
                  <div style="margin-top: 10px;">
                    <el-button type="danger" size="mini" @click="delOpt(item.id)">删除</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-container class="m-table-opt" style="padding: 5px 0 0 0;">
          <div class="m-exp-search" style="width: 100%;">
            <div style="display: flex;justify-content: center;align-items: center;">
              <div style="width: 100px; text-align: right;">订单号码：</div>
              <el-input type="text" size="small" v-model="searchForm.tradeNo"  placeholder="搜索用户提供的订单号" />
            </div>
            <div style="display: flex;justify-content: center;align-items: center;">
              <div style="width: 130px; text-align: right;">提交电话：</div>
              <el-input type="text" size="small" v-model="searchForm.phone"  placeholder="搜索用户提供的电话号码" />
            </div>
            <div style="display: flex;justify-content: center;align-items: center;">
              <div style="width: 100px; text-align: right;">下单时间：</div>
              <el-date-picker
                v-model="pickerTime"
                type="datetimerange"
                :default-time="['00:00:00','23:59:59']"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="onPickerChange"
                size="mini">
              </el-date-picker>
            </div>
            <div style="margin-left: 30px;display: flex;justify-content: center;align-items: center;">
              <el-button type="primary" size="mini" @click="listData({})">搜索</el-button>
              <el-button type="primary" size="mini" plain @click="resetForm()">重置</el-button>
            </div>
            <div style="margin-left: 30px;display: flex;justify-content: center;align-items: center;">
              所属专家：<span style="font-weight: bold; color: #ff4d51;">{{ searchForm.eName }}</span>
            </div>
<!--            <div style="margin-left: 30px;display: flex;justify-content: center;align-items: center;">-->
<!--              订单状态：-->
<!--              <span v-if="searchForm.status === '0'" style="font-weight: bold; color: #ff4d51;">未结单</span>-->
<!--              <span v-if="searchForm.status === '1'" style="font-weight: bold; color: #11c600;">已完成</span>-->
<!--            </div>-->
          </div>
        </el-container>
        <el-table :data="list" v-loading="isLoading" style="width: 100%;margin-bottom: 20px;" border size="mini">
          <el-table-column prop="name" label="姓名" width="100"></el-table-column>
          <el-table-column prop="phone" label="提交电话" width="110" align="center"></el-table-column>
          <el-table-column prop="tradeNo" label="订单号码" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="payMoney" label="支付金额" width="90" align="center">
            <template slot-scope="scope">
              {{ scope.row.payMoney }} 元
            </template>
          </el-table-column>
          <el-table-column prop="payMoney" label="支付方式" align="center" width="100">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.payType === 'ios'" type="success" size="mini">苹果支付</el-tag>
              <el-tag v-else type="primary" size="mini">安卓支付</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="projectName" label="企业/项目名称" width="" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作" width="100" align="center">
            <template slot-scope="scope">
              <div style="display: flex; justify-content: space-between;">
                <el-button type="success" size="mini" @click="openProblemForm(scope.row.explain, scope.row.name, scope.row.phone)" plain>咨询问题</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="payDate" label="下单时间" width="150" align="center" show-overflow-tooltip></el-table-column>
<!--          <el-table-column prop="callSecond" label="通话时长" width="80" align="center">-->
<!--            <template slot-scope="scope">-->
<!--              <div>-->
<!--                {{ timeCc(scope.row.callSecond) }}-->
<!--              </div>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column prop="callSecond" label="通话次数" width="70" align="center">
            <template slot-scope="scope">
              <div>
                {{ scope.row.callNum }} 次
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="limitDate" label="到期时间" width="150" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="status" label="结单状态" width="120" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status === '1'" type="success" size="mini">手动结单</el-tag>
              <el-tag v-if="scope.row.status === '0' && checkTime(scope.row.limitDate) === true" type="danger" size="mini">未结单</el-tag>
              <el-tag v-if="scope.row.status === '0' && checkTime(scope.row.limitDate) === false" type="info" size="mini">自动结单</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100" align="center">
            <template slot-scope="scope">
              <div style="display: flex; justify-content: center; align-items: center;">
                <el-button v-if="scope.row.status === '1'" type="warning" size="mini" plain>已结束</el-button>
                <el-button v-else type="warning" size="mini" @click="openCloseForm(scope.row.tradeNo)" plain>结束订单</el-button>
              </div>
            </template>
          </el-table-column>
<!--          <el-table-column label="操作" width="100" align="center">-->
<!--            <template slot-scope="scope">-->
<!--              <div style="display: flex; justify-content: space-between;">-->
<!--                <el-button type="warning" size="mini" @click="openRecoveryForm(scope.row.tradeNo)" plain>恢复订单</el-button>-->
<!--              </div>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column label="备注" width="80" align="center">
            <template slot-scope="scope">
              <div>
                <el-button type="warning" size="mini" @click="openRemarksForm(scope.row.tradeNo, scope.row.remarks)" plain>备注</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="searchForm.pageNo"
          :page-size="10"
          layout="total, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 订单备注 -->
    <el-dialog title="备注信息" :visible.sync="remarksState" width="500px" center :close-on-click-modal="false">
      <div class="m-open-coop-container" v-loading="isRemarksLoading">
        <el-form :model="remarksForm" ref="remarksForm" label-width="80px" style="padding-right: 10px;">
          <el-form-item label="备注内容: " prop="remarks">
            <el-input v-model="remarksForm.remarks" placeholder="输入备注" type="textarea" :rows="3"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-foote" style="text-align: center;">
          <el-button @click="remarksState = false">取 消</el-button>
          <el-button type="primary" @click="saveRemarksForm()">确 定</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 咨询问题 -->
    <el-dialog title="咨询问题" :visible.sync="openProblemState" width="500px" center :close-on-click-modal="false">
      <div class="m-open-coop-container">
        <div style="margin-bottom: 20px;">
          <div style="padding-right: 20px;display: flex;margin-bottom: 10px;">
            <div style="width: 100px;padding-top: 8px;text-align: right;">
              提交姓名：
            </div>
            <div style="border: 1px solid #c9c9c9;padding: 7px 10px 7px 10px;width: 100%;border-radius: 5px;">
              {{ problemForm.name }}
            </div>
          </div>
          <div style="padding-right: 20px;display: flex;margin-bottom: 10px;">
            <div style="width: 100px;padding-top: 8px;text-align: right;">
              提交电话：
            </div>
            <div style="border: 1px solid #c9c9c9;padding: 7px 10px 7px 10px;width: 100%;border-radius: 5px;">
              {{ problemForm.phone }}
            </div>
          </div>
          <div style="padding-right: 20px;display: flex;">
            <div style="width: 100px;padding-top: 8px;text-align: right;">
              提交问题：
            </div>
            <div style="border: 1px solid #c9c9c9;padding: 7px 10px 10px 10px;width: 100%;min-height: 200px;border-radius: 5px;">
              {{ problemForm.explain }}
            </div>
          </div>
        </div>
        <div slot="footer" class="dialog-foote" style="text-align: center;">
          <el-button type="primary" @click="openProblemState = false">关 闭</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 专家选项弹窗 -->
    <el-dialog title="专家信息" :visible.sync="openOptFormState" @close='closeOptFormDialog' width="700px" center :close-on-click-modal="false">
      <div class="m-open-coop-container" v-loading="optFormLoading">
        <el-form :model="optForm" :rules="optFormRules" ref="optForm" label-width="130px">
          <el-form-item label="专家图片: " prop="imgPath">
            <div style="display: flex;">
              <div style="width: 35%;">
                <el-upload
                  drag
                  :action="uploadAction"
                  :headers="myHeaders"
                  accept=".jpg, .png"
                  :limit="1"
                  :file-list="fileLists"
                  :on-success="imgSuccess"
                  :on-remove="imgRemove">
                  <div style="font-size: 12px; line-height: 26px;display: flex; flex-wrap: wrap;align-items: center; height: 169px;">
                    <div>
                      <div style="width: 100%;"><i style="font-size: 28px" class="el-icon-upload2"></i></div>
                      <div style="width: 100%;text-align: center;">拖拽或<em style="color: #1c9dff">点击上传</em></div>
                    </div>
                  </div>
                </el-upload>
              </div>
              <div style="width: 65%">
                <div style="width: 195px; height: 169px;margin-left: 20px;border-radius: 8px;overflow: hidden;">
                  <img :src="ossURL + optForm.imgPath" alt="" width="100%" height="100%">
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="专家姓名: " prop="eName">
            <el-input v-model="optForm.eName"></el-input>
          </el-form-item>
          <el-form-item label="联系电话: " prop="phone">
            <el-input v-model="optForm.phone"></el-input>
          </el-form-item>
          <div style="border: 1px solid #DCDFE6;padding: 0 22px 0 0;margin-bottom: 22px;border-radius: 5px;background-color: #cfe9ff;">
            <div style="height: 40px;font-size: 12px;color: #ff4d51;display: flex;align-items: center;justify-content: center;">
              提示：变更绑定后，变更之前的专家业务数据将归零
            </div>
            <div style="display: flex;">
              <div style="width: 79%;">
                <el-form-item label="绑定用户ID: " prop="userId">
                  <el-input v-model="optForm.userId" disabled></el-input>
                </el-form-item>
              </div>
              <div style="width: 20%;display: flex;align-items: center;justify-content: center;padding: 0 0 22px 20px;">
                <el-button type="primary" @click="openPhoneForm()" size="small">变更绑定</el-button>
              </div>
            </div>
          </div>
          <el-form-item label="专项: " prop="eMajor">
            <el-input v-model="optForm.eMajor" ></el-input>
          </el-form-item>
          <el-form-item label="专家类型: " prop="eTypeText">
            <el-input v-model="optForm.eTypeText" ></el-input>
          </el-form-item>
          <el-form-item label="说明简要: " prop="eTips">
            <el-input v-model="optForm.eTips" ></el-input>
          </el-form-item>
          <el-form-item label="人物说明标题: " prop="explainTitle">
            <el-input v-model="optForm.explainTitle" ></el-input>
          </el-form-item>
          <el-form-item label="人物说明内容: " prop="explain">
            <el-input v-model="optForm.explain" type="textarea" :rows="2" ></el-input>
          </el-form-item>
          <div style="border: 1px solid #DCDFE6;padding: 0 22px 0 0;margin-bottom: 22px;border-radius: 5px;background-color: #cfe9ff;">
            <div style="height: 40px;font-size: 12px;color: #ff4d51;display: flex;align-items: center;justify-content: center;">
              提示：苹果端修改金额需要在苹果开发平台申请修改金额，审核通过后修改金额，新增专家同理。
            </div>
            <el-form-item label="服务费用标题: " prop="serviceTitle">
              <el-input v-model="optForm.serviceTitle" ></el-input>
            </el-form-item>
            <el-form-item label="服务费用内容: " prop="serviceCont">
              <el-input v-model="optForm.serviceCont" type="text" ></el-input>
            </el-form-item>
            <el-form-item label="ios服务费用内容: " prop="iosServiceCont">
              <el-input v-model="optForm.iosServiceCont" type="text" ></el-input>
            </el-form-item>
            <el-form-item label="安卓端金额: " prop="money">
              <el-input v-model="optForm.money" type="number" ></el-input>
            </el-form-item>
            <el-form-item label="苹果端金额: " prop="iosMoney">
              <el-input v-model="optForm.iosMoney" type="number" ></el-input>
            </el-form-item>
            <el-form-item label="上班时间: " prop="toWorkTime">
              <el-time-select
                v-model="optForm.toWorkTime"
                :picker-options="{start: '06:00', step: '00:15', end: '22:00'}"
                placeholder="选择时间">
              </el-time-select>
            </el-form-item>
            <el-form-item label="下班时间: " prop="iosServiceCont">
              <el-time-select
                v-model="optForm.afterWorkTime"
                :picker-options="{start: '06:00', step: '00:15', end: '22:00'}"
                placeholder="选择时间">
              </el-time-select>
            </el-form-item>
          </div>
          <el-form-item label="服务价值标题: " prop="valueTitle">
            <el-input v-model="optForm.valueTitle" ></el-input>
          </el-form-item>
          <el-form-item label="服务价值内容: " prop="valueCont">
            <el-input v-model="optForm.valueCont" type="textarea" :rows="2" ></el-input>
          </el-form-item>
          <el-form-item label="服务详情标题: " prop="detailsTitle">
            <el-input v-model="optForm.detailsTitle" ></el-input>
          </el-form-item>
          <el-form-item label="服务详情内容: " prop="detailsCont">
            <el-input v-model="optForm.detailsCont" type="textarea" :rows="2"></el-input>
          </el-form-item>
          <el-form-item label="咨询须知标题: " prop="tipsHtmlTitle">
            <el-input v-model="optForm.tipsHtmlTitle" ></el-input>
          </el-form-item>
          <el-form-item label="咨询须知内容: " prop="tipsHtml">
            <div style="height: 400px;width: 500px;">
              <quill-editor
                style="height: 400px"
                class="ql-editor"
                v-model="optForm.tipsHtml"
                ref="myQuillEditor"
                :options="editorOption"
                @ready="onEditorReady($event)">
              </quill-editor>
            </div>
          </el-form-item>
          <el-form-item label="logo右侧标题: " prop="logoTitle">
            <el-input v-model="optForm.logoTitle" ></el-input>
          </el-form-item>
          <el-form-item label="排序: " prop="sort">
            <el-input v-model="optForm.sort" type="number" ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-foote" style="text-align: center;">
          <el-button @click="openOptFormState = false">取 消</el-button>
          <el-button type="primary" @click="submitOptForm()">确 定</el-button>
        </div>
      </div>
      <el-dialog title="标记已读" :visible.sync="phoneFormState" width="500px" @close="closePhoneFormDialog" center append-to-body="true">
        <div class="m-open-coop-container" v-loading="phoneFormLoading">
          <div style="text-align: center;">
            <el-form :inline="true" :model="searchUserForm" ref="searchForm">
              <el-form-item label="用户电话:" size="mini">
                <el-input type="text" v-model="searchUserForm.phone"  placeholder="搜索用户电话" />
              </el-form-item>
              <el-form-item style="margin-left: 10px;" size="mini">
                <el-button type="primary" @click="listUserData(searchUserForm.phone)">搜索</el-button>
              </el-form-item>
            </el-form>
          </div>
          <el-table :data="userList" v-loading="isUserLoading" style="width: 100%;margin-bottom: 20px;" border size="mini">
            <el-table-column prop="phone" label="电话" width="130" align="center"></el-table-column>
            <el-table-column prop="nickname" label="用户昵称" width=""></el-table-column>
            <el-table-column label="操作" width="120" align="center">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" @click="submitChange(scope.row.id)" plain>确认变更</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div slot="footer" class="dialog-foote" style="text-align: center;">
            <el-button type="primary" @click="phoneFormState = false" size="mini">取 消</el-button>
          </div>
        </div>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor'
export default {
  components: { // 使用编辑器
    quillEditor
  },
  name: 'doctorExpert',
  data () {
    return {
      pickerTime: '',
      isLoading: true,
      isMoneyLoading: false,
      optLoading: true,
      openFormState: false,
      openOptFormState: false,
      formLoading: false,
      optFormLoading: false,
      ossURL: this.$httpConf.ossURL,
      optList: [], // 报名选项列表
      list: [], // 用户提交报名列表
      phoneFormState: false, // 变更绑定弹窗
      phoneFormLoading: false, // 变更绑定弹窗加载状态
      isUserLoading: false, // 变更绑定弹窗加载状态
      userList: [], // 变更绑定弹窗用户列表
      searchUserForm: {
        cityName: '',
        proviceCoopId: '',
        cooperatorId: '',
        specialId: '',
        teamId: '',
        salesmanId: '',
        phone: '',
        startDate: '',
        endDate: '',
        pageNo: 1
      },
      optIsActive: false,
      optForm: { // 报名选项form
        id: '',
        userId: '',
        phone: '',
        imgPath: '',
        eName: '',
        eMajor: '',
        eTypeText: '',
        eTips: '',
        explainTitle: '',
        explain: '',
        serviceTitle: '',
        serviceCont: '',
        valueTitle: '',
        valueCont: '',
        detailsTitle: '',
        detailsCont: '',
        tipsHtmlTitle: '',
        tipsHtml: '',
        logoTitle: '',
        sort: '',
        status: '',
        createBy: '',
        updateBy: '',
        money: 0.0,
        iosMoney: 0.0,
        toWorkTime: '',
        afterWorkTime: '',
        iosServiceCont: ''
      },
      uploadAction: '',
      myHeaders: { Authorization: JSON.parse(window.sessionStorage.user).Authorization },
      fileLists: [],
      imgDialogVisible: false,
      isRemarksLoading: false,
      closeSubForm: { // 提交已读form
        tradeNo: '',
        remarks: ''
      },
      editorOption: {},
      optFormRules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ]
      },
      total: 0,
      searchForm: {
        pageNo: 1,
        phone: '',
        tradeNo: '',
        expertId: '',
        startDate: '',
        endDate: '',
        eName: ''
      },
      remarksState: false,
      remarksForm: {
        tradeNo: '',
        remarks: ''
      },
      allMoney: 0,
      allIosMoney: 0,
      allAndroidMoney: 0,
      expertMoney: 0,
      expertIosMoney: 0,
      expertAndroidMoney: 0,
      openProblemState: false,
      problemForm: {
        explain: '',
        name: '',
        phone: ''
      }
    }
  },
  created () {
    // 赋值图片上传路径
    this.uploadAction = this.$httpConf.baseURL + '/doctorExpert/uploadImage'
  },
  editor () {
    return this.$refs.myQuillEditor.quill
  },
  methods: {
    openProblemForm (explain, name, phone) {
      this.problemForm.explain = explain
      this.problemForm.name = name
      this.problemForm.phone = phone
      this.openProblemState = true
    },
    timeCc (value) {
      // 如果value不是数字或者小于0，则直接返回00:00:00
      if (isNaN(value) || value < 0) {
        return '00:00:00'
      }

      // 计算小时、分钟和秒
      let hours = Math.floor(value / 3600)
      let minutes = Math.floor((value % 3600) / 60)
      let seconds = value % 60

      // 格式化为00:00:00
      hours = hours < 10 ? '0' + hours : hours
      minutes = minutes < 10 ? '0' + minutes : minutes
      seconds = seconds < 10 ? '0' + seconds : seconds

      return hours + ':' + minutes + ':' + seconds
    },
    onPickerChange (e) {
      let startDate = new Date(e[0])
      let endDate = new Date(e[1])
      this.searchForm.startDate = startDate.getFullYear() +
        '-' + (startDate.getMonth() < 10 ? '0' + (startDate.getMonth() + 1) : (startDate.getMonth() + 1)) +
        '-' + (startDate.getDate() < 10 ? '0' + startDate.getDate() : startDate.getDate())
      this.searchForm.endDate = endDate.getFullYear() +
        '-' + (endDate.getMonth() < 10 ? '0' + (endDate.getMonth() + 1) : (endDate.getMonth() + 1)) +
        '-' + (endDate.getDate() < 10 ? '0' + endDate.getDate() : endDate.getDate())
    },
    closePhoneFormDialog () {
      this.searchUserForm = {
        cityName: '',
        proviceCoopId: '',
        cooperatorId: '',
        specialId: '',
        teamId: '',
        salesmanId: '',
        phone: '',
        startDate: '',
        endDate: '',
        pageNo: 1
      }
      this.userList = []
    },
    openPhoneForm () {
      this.phoneFormState = true
    },
    checkTime (timeStr) {
      const limitTime = new Date(timeStr).getTime()
      const newTime = new Date().getTime()
      if (limitTime > newTime) {
        return true
      } else {
        return false
      }
    },
    // 分页
    handleCurrentChange (val) {
      this.listData({pageNo: val})
    },
    resetForm () {
      this.searchForm.tradeNo = ''
      this.searchForm.phone = ''
      this.searchForm.startDate = ''
      this.searchForm.endDate = ''
      this.pickerTime = ''
      this.listData({})
    },
    openNewOpt () {
      this.openOptFormState = true
    },
    onEditorReady (editor) {
      console.log(editor)
    },
    // 删除图片
    imgRemove () {
      this.optForm.imgPath = ''
      this.fileLists = []
    },
    // 图片上传成功
    imgSuccess (response, file, fileList) {
      if (file.response.status === 200) {
        this.optForm.imgPath = file.response.data
        this.fileLists = [{url: this.$httpConf.ossURL + file.response.data}]
        this.$message.success('上传成功')
      }
    },
    closeFormDialog () {
      this.closeSubForm = {
        tradeNo: '',
        remarks: ''
      }
    },
    getExpertStatus (status) {
      return status === '1'
    },
    submitExpertStatus (expertId, status) {
      let _this = this
      let aa = status === '1' ? ' 关闭 ' : ' 开启 '
      let bb = status === '1' ? '0' : '1'
      this.$messageBox.confirm('请确认是否' + aa + '本项服务?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'success'
      }).then(() => {
        this.$axios.post('/doctorExpert/changeExpertStatus', {expertId: expertId, status: bb})
          .then((res) => {
            if (res.status === 200) {
              _this.$message.success(res.msg)
              _this.optData()
            } else {
              _this.$message.error(res.msg)
            }
          })
      }).catch(() => {
        this.$message.info('已取消提交')
      })
    },
    closeOptFormDialog () {
      this.optForm = {
        id: '',
        imgPath: '',
        eName: '',
        eMajor: '',
        eTypeText: '',
        eTips: '',
        explainTitle: '',
        explain: '',
        serviceTitle: '',
        serviceCont: '',
        valueTitle: '',
        valueCont: '',
        detailsTitle: '',
        detailsCont: '',
        tipsHtmlTitle: '',
        tipsHtml: '',
        logoTitle: '',
        sort: '',
        status: '',
        createBy: '',
        updateBy: '',
        money: 0.0,
        iosMoney: 0.0,
        toWorkTime: '',
        afterWorkTime: '',
        iosServiceCont: ''
      }
      this.optIsActive = false
      this.fileLists = []
    },
    openOptForm (item) {
      this.optForm = {
        id: item.id,
        userId: item.userId,
        phone: item.phone,
        imgPath: item.imgPath,
        eName: item.eName,
        eMajor: item.eMajor,
        eTypeText: item.eTypeText,
        eTips: item.eTips,
        explainTitle: item.explainTitle,
        explain: item.explain,
        serviceTitle: item.serviceTitle,
        serviceCont: item.serviceCont,
        valueTitle: item.valueTitle,
        valueCont: item.valueCont,
        detailsTitle: item.detailsTitle,
        detailsCont: item.detailsCont,
        tipsHtmlTitle: item.tipsHtmlTitle,
        tipsHtml: item.tipsHtml,
        logoTitle: item.logoTitle,
        sort: item.sort,
        status: item.status,
        createBy: item.createBy,
        updateBy: item.updateBy,
        money: item.money,
        iosMoney: item.iosMoney,
        toWorkTime: item.toWorkTime,
        afterWorkTime: item.afterWorkTime,
        iosServiceCont: item.iosServiceCont
      }
      this.optIsActive = item.status === '1'
      this.openOptFormState = true
    },
    openForm (id) {
      this.openFormState = true
      this.closeSubForm.tradeNo = id
    },
    // 恢复订单状态，包括限制时间
    openCloseForm (tradeNo) {
      let _this = this
      this.$messageBox.confirm('此操作将结束当前订单状态, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.$axios.post('/doctorExpert/closeTrade', {tradeNo: tradeNo})
          .then((res) => {
            if (res.status === 200) {
              _this.$message.success(res.msg)
              _this.listData({})
            } else {
              _this.$message.error(res.msg)
            }
          })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    // 恢复订单状态，包括限制时间
    openRecoveryForm (tradeNo) {
      let _this = this
      this.$messageBox.confirm('此操作将恢复当前订单状态, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.$axios.post('/doctorExpert/recoveryTrade', {tradeNo: tradeNo})
          .then((res) => {
            if (res.status === 200) {
              _this.$message.success(res.msg)
              _this.listData({})
            } else {
              _this.$message.error(res.msg)
            }
          })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    // 变更绑定用户
    submitChange (userId) {
      this.$messageBox.confirm('此操作将变更绑定用户，变更之前专家数据清零, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.optForm.userId = userId
        this.phoneFormState = false
      }).catch(() => {
        this.$message.info('已取消')
      })
    },
    delOpt (id) {
      let _this = this
      this.$messageBox.confirm('此操作将永久删除当前项, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.$axios.post('/doctorExpert/del', {id: id})
          .then((res) => {
            if (res.status === 200) {
              _this.$message.success(res.msg)
              _this.optData()
            } else {
              _this.$message.error(res.msg)
            }
          })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    submitOptForm () {
      let _this = this
      this.optForm.status = _this.optIsActive ? '1' : '0'
      this.$refs['optForm'].validate((valid) => {
        if (valid) {
          _this.optFormLoading = true
          this.$axios.post('/doctorExpert/saveExpert', _this.optForm)
            .then((res) => {
              if (res.status === 200) {
                _this.$message.success(res.msg)
                _this.openOptFormState = false
                _this.optData()
              } else {
                _this.$message.error(res.msg)
              }
              _this.optFormLoading = false
            })
        } else {
          return false
        }
      })
    },
    // 用户列表
    listUserData (phone) {
      let _this = this
      this.isUserLoading = true
      this.searchUserForm.phone = phone
      _this.userList = []
      this.$axios.post('/app/user/list', this.searchUserForm)
        .then((res) => {
          _this.userList = res.data.rows
          _this.isUserLoading = false
        })
    },
    // 选项列表
    optData () {
      let _this = this
      _this.optLoading = true
      _this.optList = []
      this.$axios.post('/doctorExpert/expertList')
        .then((res) => {
          _this.optList = res.data
          _this.listData({expertId: res.data[0].id, eName: res.data[0].eName})
          _this.optLoading = false
        })
    },
    // 搜索列表
    listData ({pageNo = 1, expertId = '', eName = ''}) {
      this.searchForm.pageNo = pageNo
      this.searchForm.expertId = expertId !== '' ? expertId : this.searchForm.expertId
      this.searchForm.eName = eName !== '' ? eName : this.searchForm.eName
      let _this = this
      _this.isLoading = true
      _this.list = []
      this.$axios.post('/doctorExpert/applyList', _this.searchForm)
        .then((res) => {
          _this.total = res.data.total
          _this.list = res.data.rows
          _this.isLoading = false
          _this.searchMoney()
        })
    },
    openRemarksForm (tradeNo, remarks) {
      this.remarksForm.tradeNo = tradeNo
      this.remarksForm.remarks = remarks
      this.remarksState = true
    },
    // 提交订单备注
    saveRemarksForm () {
      let _this = this
      _this.isRemarksLoading = true
      this.$axios.post('/doctorExpert/saveTradeNoRemarks', _this.remarksForm)
        .then((res) => {
          if (res.status === 200) {
            _this.$message({
              message: '提交成功',
              duration: 1200,
              type: 'success',
              center: true
            })
            _this.remarksState = false
            this.remarksForm.tradeNo = ''
            this.remarksForm.remarks = ''
            _this.isRemarksLoading = false
            _this.listData({})
          }
        })
    },
    searchMoney () {
      let _this = this
      _this.isMoneyLoading = true
      this.$axios.post('/doctorExpert/expertMoney', _this.searchForm)
        .then((res) => {
          if (res.status === 200) {
            _this.allMoney = res.data.allMoney
            _this.allIosMoney = res.data.allIosMoney
            _this.allAndroidMoney = res.data.allAndroidMoney
            _this.expertMoney = res.data.expertMoney
            _this.expertIosMoney = res.data.expertIosMoney
            _this.expertAndroidMoney = res.data.expertAndroidMoney
            _this.isMoneyLoading = false
          } else {
            _this.$message({
              message: '金额查询失败',
              duration: 1200,
              type: 'error',
              center: true
            })
            _this.isMoneyLoading = false
          }
        })
    }
  },
  mounted () {
    this.optData()
  }
}
</script>

<style>

.el-dialog {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.el-dialog__header {
  align-self: center;
}

.opt-selected {
  background-color: #1c9dff;
  color: #ffffff;
}

.el-upload-dragger {
  width: 170px;
  height: 130px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<style scoped>

.m-dis-box {
  position: relative;
}

.m-dis-box-ti {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.m-dis-box-ti-tips {
  color: #c10006;
  width: 260px;
  background-color: #e3efff;
  border-radius: 5px;
  height: 39px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.m-enroll-opt {
  display: flex;
  position: relative;
  height: 182px;
  width: 100%;
  padding-bottom: 10px;
  margin: 10px 0 0 0;
}

.scroll-container {
  overflow-x: auto; /* 使容器可以横向滚动 */
  white-space: nowrap; /* 确保列表项不换行 */
}

.scroll-list {
  display: inline-flex; /* 使列表项横向排列 */
}

.m-total-item {
  font-size: 16px;
  padding: 8px 20px;
  background-color: #ffffff;
  font-weight: bold;
  color: #3a8ee6;
  border-radius: 5px;
  border: 1px solid #666666;
  margin-right: 20px;
}

.m-expert-money {
  display: flex;
  align-items: center;
}

.m-exp-search {
  display: flex;
  padding: 6px 30px 6px 30px;
  border-top: 1px solid #EBEEF5;
  border-left: 1px solid #EBEEF5;
  border-right: 1px solid #EBEEF5;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.m-enroll-opt-item {
  margin-right: 20px;
  border: 1px solid #f2f2f2;
  color: #666666;
  display: flex;
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  width: 240px;
  height: 163px;
}

.m-enroll-opt-item-left {
  width: 150px;
  border-right: 1px solid #f2f2f2;
  cursor: pointer;
}

.m-enroll-opt-item-right {
  width: 90px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}

.m-enroll-opt-tit {
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  border-bottom: 1px solid #f2f2f2;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.m-enroll-opt-img {
  width: 150px;
  height: 133px;
  position: relative;
}

.m-enroll-opt-img img {
  object-fit: cover;
}

.m-enroll-opt-img-click {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background: rgba(0,0,0,0.5);
  display: none;
}

.m-enroll-opt-img-t {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0,0,0,1);
  font-size: 12px;
  padding: 5px 0;
}

.opt-img-click-text {
  width: 100%;
  height: 100%;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.m-enroll-opt-item-left:hover .m-enroll-opt-tit{
  background-color: #1c9dff;
  color: #ffffff;
}

.m-enroll-opt-item-left:hover .m-enroll-opt-img-click{
  display: block;
}

</style>



// WEBPACK FOOTER //
// src/components/doctorExpert/DoctorExpert.vue